import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";
import CreatePostLicenceIsValidAction from "./CreatePostLicenceIsValidAction";
import { POST } from "../adapters/xhr";

export default function (licenceApplicationId, paymentAmount, isReviewCompletion = false) {
    return async (dispatch, getState) => {
        dispatch(CreateDataRetrievalBegunAction());
        const { reviewAndDeclaration, requiredEquipment, requiredEpirbs, auth } = getState();

        try {
            // If this is a review completion, handle it first
            if (isReviewCompletion) {
                const response = await fetch(`/api/LicenceApplication/CompleteReview?licenceApplicationId=${licenceApplicationId}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(`Failed to complete review: ${response.status} ${errorText}`);
                }

                const result = await response.json();
                if (!result.success) {
                    throw new Error(result.message || 'Failed to complete review');
                }
            }

            // Handle the declaration part
            const newReviewAndDeclarationDetail = {
                licenceApplicationId: Number(licenceApplicationId) || 0,
                created: new Date(),
                updated: new Date(),
                declarationAccepted: reviewAndDeclaration.declarationsCheckbox || false
            };

            const hasRequiredEquipment = requiredEquipment != null;
            const outstanding = requiredEquipment?.outstandingRequiredEquipment || [];
            const outstandingGroups = requiredEquipment?.outstandingRequiredEquipmentGrouped || [];

            const hasRequiredEpirbs = requiredEpirbs != null;
            const outstandingEpirbs = requiredEpirbs?.outstandingEpirbs || [];

            const isNotValid = (hasRequiredEquipment && (outstanding.length > 0 || outstandingGroups.length > 0)) ||
                (hasRequiredEpirbs && outstandingEpirbs.length > 0);

            await POST("/api/ApplicantDeclaration/AddRecord", newReviewAndDeclarationDetail);

            dispatch(CreatePostLicenceIsValidAction(licenceApplicationId, !isNotValid));
            
            // Create payment record synchronously if one doesn't already exist and payment is required
            if (paymentAmount > 0) {
                const paymentModel = {
                    id: 0,
                    transId: null,
                    licenceApplicationId: Number(licenceApplicationId) || 0,
                    paymentAmount: paymentAmount,
                    created: new Date(),
                    createdBy: auth?.user?.email || ""
                };
                
                try {
                    const paymentResponse = await POST("api/LicenceApplication/NewLicencePayment", paymentModel);
                    if (paymentResponse.status === 200) {
                        dispatch({
                            type: "LICENCE_PAYMENT_RETRIEVED",
                            data: paymentResponse.data.licencePayment
                        });
                    } else {
                        console.error(`Payment creation failed with status ${paymentResponse.status}`);
                    }
                } catch (paymentError) {
                    console.error('Payment creation failed:', paymentError);
                    // Payment creation failed, but continue with the declaration
                }
            }

            dispatch(CreateDataRetrievalEndedAction());
            return { success: true };
        } catch (error) {
            console.error('Error in CreateAddReviewAndDeclarationsAction:', error);
            dispatch(CreateDataRetrievalEndedAction());
            throw error;
        }
    };
}
